/* eslint-disable */
smoothScroll = function () {
  var topOffset = '';

  if ($('.navbar').hasClass('no-sub')) {
      topOffset = 112;
  } else if ($('.navbar').hasClass('has-sub')) {
      topOffset = 112;
  } else if ($('.gallery-preferences').length) {
      topOffset = 62;
  } else {
      topOffset = 0;
  }

  $('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('[href*="#gallery"]')
  .not('[href*="#carousel"]')
  .not('[data-toggle="tab"]')
  .not('[data-toggle="collapse"]')
  .not('[class*="share-toggle"]')
  .click(function(event) {
      $(".main-navigation").addClass('affix--hidden');

      // On-page links
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          // Does a scroll target exist?
          if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $('html, body').animate({
                  scrollTop: target.offset().top - topOffset
              }, 1000, function() {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  $target.focus();

                  if ($target.is(":focus")) { // Checking if the target was focused
                      return false;
                  } else {
                      $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                      $target.focus(); // Set focus again
                  };
              });
          }
      }
  });
};

smoothScroll();
